"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
/**
 * Get First element of object
 *
 * @param  {Object} obj Object data
 * @return {any}        Element data
 */
function getFirstElement(obj) {
    if (lodash_1.isEmpty(obj)) {
        return null;
    }
    return obj[Object.keys(obj)[0]];
}
exports.getFirstElement = getFirstElement;
/**
 * Get first key of object
 *
 * @param  {Object} obj Object data
 * @return {string}     Object key
 */
function getFirstKey(obj) {
    if (lodash_1.isEmpty(obj)) {
        return null;
    }
    return Object.keys(obj)[0];
}
exports.getFirstKey = getFirstKey;
function stripObject(input, emptyValues) {
    if (emptyValues === void 0) { emptyValues = [null, undefined, ""]; }
    return Object.keys(input).reduce(function (o, k) {
        var _a;
        return emptyValues.indexOf(input[k]) === -1
            ? __assign({}, o, (_a = {}, _a[k] = input[k], _a)) : o;
    }, {});
}
exports.stripObject = stripObject;
function diff(obj1, obj2) {
    return Object.keys(obj1).reduce(function (r, k) {
        var _a;
        return obj2 === undefined
            || obj1[k] === obj2[k] ? r : __assign((_a = {}, _a[k] = obj2[k], _a), r);
    }, {});
}
exports.diff = diff;
/**
 * Convert object to array
 *
 * @param  {Object}        input Object data
 * @param  {IAssignOption} opts  Option data
 *
 * @return {Array<any>}        Array data
 */
function objectToArray(input, opts) {
    var options = __assign({ excepts: [], keyName: "key", valueName: "value" }, opts);
    return Object.keys(input).filter(function (key) { return opts.excepts.indexOf(key) !== -1; })
        .map(function (key) {
        var _a;
        return (_a = {}, _a[options.keyName] = key, _a[options.valueName] = input[key], _a);
    });
}
exports.objectToArray = objectToArray;
function deepCamelCaseObject(src) {
    return Object.keys(src).reduce(function (r, k) {
        switch (typeof src[k]) {
            case "object":
                if (Array.isArray(src[k])) {
                    r[lodash_1.camelCase(k)] = src[k].length > 0 && typeof src[k][0] === "object"
                        ? src[k].map(deepCamelCaseObject) : src[k];
                }
                else {
                    r[lodash_1.camelCase(k)] = deepCamelCaseObject(src[k]);
                }
                break;
            default:
                r[lodash_1.camelCase(k)] = src[k];
        }
        return r;
    }, {});
}
exports.deepCamelCaseObject = deepCamelCaseObject;
//# sourceMappingURL=object.js.map